import { createContext, useContext, useState } from "react";

const NotificationContext = createContext()

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null)

  const show = (message) => {
    setNotification(message)
    setTimeout(() => setNotification(null), 3000) // Auto-hide after 3s
  }

  return (
    <NotificationContext.Provider value={{ show }}>
      {children}
      <div className={`notification-container ${notification ? 'show' : ''}`}>
        {notification && (
          <>
            <span className="message">{notification}</span>
            <button className="close-btn" onClick={() => setNotification(null)}>x</button>
          </>
        )}
      </div>
    </NotificationContext.Provider>
  )
}

export const useNotification = () => useContext(NotificationContext)